<template>
   <div class="tag-search mb-3" v-if="tags.length || showsCreateItem">

        <div class="tag-search__item"
            v-for="tag in tags"
            :key="tag.value"
            @click.prevent="selectTag(tag)"
        >
            {{ tag.value }}
        </div>
    </div>
</template>

<script setup>
import debounce from '~/utils/debounce';
import tagsClient from '../../services/tagsClient';

import { computed, ref, watch } from 'vue';
import { validate } from '../../utils/tags';

const props = defineProps({
    search: {
        type: String,
        default: null
    },
    canCreate: {
        type: Boolean,
        default: false,
    }
})

const emit = defineEmits(['selected', 'create']);

const tags = ref([]);
const loading = ref(false);

const selectTag = ({id, value}) => {
    if(!id) {
        emit('create', value.toLowerCase());
    } else {
        emit('selected', {id, tag_name: value.toLowerCase()});
    }

    tags.value = [];
}

const showsCreateItem = computed(() => props.canCreate && !loading.value)

const runSearch = (search) => {
    loading.value = true;

    tagsClient.tagsAutocomplete(Spark.state.currentTeam.id, {
        'query': search.trim(),
        per_page: 5
    })
        .then(response => {
            if (response.data.data) {
               tags.value = response.data.data.map(({id, value}) => ({
                    id,
                    value: value.toLowerCase(),
               }));
            }
        })
        .finally(() => {
            if (!tags.value.find(({value}) => value === search)) {
                tags.value.unshift({
                    id: null,
                    value: search.toLowerCase()
                })
            }

            loading.value = false;
        });
};

const debouncedSearch = debounce(runSearch, 350);

watch(
    () => props.search,
    search => {
        if(search?.trim().length) {
            if (!validate({tag_name: search})) {
                return;
            }

            debouncedSearch(search.toLowerCase());
        }
    },
)
</script>

<style lang="scss" scoped>
.tag-search {
    max-height: 150px;
    overflow: auto;
}
.tag-search__item {
    padding-top: 4px;
    padding-bottom: 4px;
    border-bottom: 1px solid var(--color-grey-50);
    cursor: pointer;
    &:hover {
        background: var(--color-primary-200);
    }
}
</style>
